import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { fetchAdminMe, adminKeys } from '@/features/admin/queries'

// Layout route for the admin panel. Server gates every /v1/admin/* call,
// but we also short-circuit the SPA so non-admins see a redirect, not an
// empty page that 403s when its queries fire.
export const Route = createFileRoute('/_authenticated/admin')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData({
      queryKey:  adminKeys.me(),
      queryFn:   fetchAdminMe,
      staleTime: 5 * 60_000,
    })
    if (!me.isAdmin) {
      throw redirect({ to: '/home' })
    }
  },
  component: AdminLayout,
})

function AdminLayout() {
  return <Outlet />
}
